import { colors } from '../../../../../packages/colors';

export const sx = {
  root: {
    width: '100%',
    height: '-webkit-fill-available',
    flexDirection: 'column',
    display: 'flex',
  },
  // Main section container (header, nav, content, footer)
  mainSection: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minWidth: 0,
    backgroundColor: colors.white,
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1)',
  },
  // Content wrapper (nav + content area)
  contentWrapper: {
    display: 'flex',
    flexGrow: 1,
    height: '100%',
    overflow: 'hidden',
  },
  // Footer with action buttons
  actionsContainer: {
    padding: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: `1px solid ${colors.neutral100}`,
  },
  nextBtn: {
    height: 'auto !important',
    padding: '12px 20px !important',
  },
  leaveBtn: {
    height: 'auto !important',
    padding: '12px 20px !important',
    color: `${colors.neutral800} !important`,
    border: `1px solid ${colors.neutral300} !important`,
    backgroundColor: `${colors.white} !important`,
    '&:hover': {
      backgroundColor: `${colors.neutral50} !important`,
    },
  },
  endBtn: {
    height: 'auto !important',
    padding: '12px 20px !important',
    color: `${colors.destructive600} !important`,
    backgroundColor: `${colors.destructive50} !important`,
    '&:hover': {
      backgroundColor: `${colors.destructive600} !important`,
      color: `${colors.white} !important`,
    },
  },
  endBtnInverted: {
    height: 'auto !important',
    padding: '12px 20px !important',
    color: `${colors.white} !important`,
    backgroundColor: `${colors.destructive500} !important`,
    '&:hover': {
      backgroundColor: `${colors.destructive400} !important`,
    },
  },
  restartBtn: {
    height: 'auto !important',
    padding: '12px 20px !important',
    color: `${colors.success600} !important`,
    backgroundColor: `${colors.white} !important`,
    '& svg path': {
      fill: `${colors.success600} !important`,
    },
    border: `1px solid ${colors.green100} !important`,
    '&:hover': {
      backgroundColor: `${colors.green50} !important`,
    },
  },
};
